export const  AccountSettingServicesUpdate = {
    updatePassword: "/auth/updatePassword",
    forgotPassword:"/auth/forgetPassword",
    checkAttendanceStatus:"/auth/attendance/dailyLog",
    markAttendance:"/auth/attendance/mark",
    checkLog:"/auth/attendance/log",
    updateAttendance:"auth/attendance/mark/manual",
    getAllAttendance:"/auth/attendance/log/all",
  };
    